import React, { useState, useEffect } from 'react';
import { Button } from 'selfly-ui-react/dist/components/';
import AccordionList from '../AccordionList/AccordionList';
import SearchField from '../SearchField/SearchField';

import { JOKI } from '../../JOKI';
import InnerSpinner from '../Loading/InnerSpinner';
import Spinner from 'selfly-ui-react/dist/components/Spinner';

import NoData from '../NoData/NoData'

export default function CrudTreeContainer({ crudState, crudDispatch, ...props }) {
    const [items, setItems] = useState(null);
    const [searchKey, setSearchKey] = useState('');
    const [filteredItems, setFilteredItems] = useState(null);

    // Load initial organizations
    useEffect(() => {
        async function getCrudTreeFromService() {
            const res = JOKI.ask({
                from: 'React:CrudTreeContainer',
                to: crudState.serviceId,
                key: 'getCrudTree',
            });
            res.then(r => {
                if (Array.isArray(r[crudState.serviceId])) {
                    setItems(r[crudState.serviceId]);
                }
            });
        }

        getCrudTreeFromService();

        return JOKI.on({
            from: crudState.serviceId,
            key: 'serviceUpdate',
            fn: event => {
                if (event.body) {
                    setItems(event.body);
                }
            },
        });
        // eslint-disable-next-line
    }, []);

    useEffect(() => {

        if (!Array.isArray(items)) {
            setFilteredItems(null);
            return;
        }

        const optFilters = Array.isArray(crudState.filters)
            ? crudState.filters.reduce((its, fl) => {
                  return fl.filterFn(its, fl);
              }, items)
            : items;

        setFilteredItems(
            optFilters.filter(item => {
                if (searchKey === '') {
                    return true;
                }
                return item.name.toLowerCase().includes(searchKey.toLowerCase());
            })
        );
    }, [items, searchKey, crudState.filters]);

    function newItem() {
        crudDispatch({ type: 'new', backTo: 'tree' });
    }

    function onClick(item) {
        if (crudState.loading) return;
        if (crudState.editOnRowClick) {
            crudDispatch({ type: 'edit', data: item, backTo: 'tree' });
        } else {
            crudDispatch({ type: 'show', data: item, backTo: 'tree' });
        }
    }

    return (
        <>
            <div className="page-header-title-row">
                <h3>{crudState.title}</h3>
                {crudState.loading && <Spinner size="xl" />}
                {!crudState.loading && (
                    <div className="buttons">
                        {crudState.filters &&
                            crudState.filters.map(fl => {
                                return (
                                    <Button key={fl.id} icon={fl.icon} onClick={() => fl.buttonClick(fl, props.filters)} type={fl.buttonType || 'primary'}>
                                        {fl.name}
                                    </Button>
                                );
                            })}

                        <Button icon="add" onClick={newItem}>
                            New
                        </Button>
                    </div>
                )}
                <SearchField value={searchKey} onChange={val => setSearchKey(val)} />
            </div>
            <div className="view-body">
                <div className="body-list">
                    {(filteredItems === null) && <InnerSpinner />}
                    {(filteredItems !== null && filteredItems.length === 0) && <NoData message="No location is available for the user." />}
                    {Array.isArray(filteredItems) && filteredItems.length !== 0 && (
                        <AccordionList  className="smaller-text"
                        data={filteredItems} 
                        idkey="code" 
                        childkey="children" 
                        colkeys={crudState.columns} 
                        rowOnClick={onClick} />
                    )}
                </div>
            </div>
        </>
    );
}
